/**
 * fable-discounts storefront preview.
 * Renders "was / now" prices on the PDP (#product-price) and on product cards ([data-fd-product]) from the
 * same rule evaluator the checkout Function runs (window.FableDiscounts, built from the app repo).
 * Inputs come from window.FableDiscountsCtx (snippets/fable-discounts-context.liquid).
 * Estimates only: checkout is the authority. No-ops when there are no active discounts.
 */
(function () {
  var ctx = window.FableDiscountsCtx;
  var lib = window.FableDiscounts;
  if (!ctx || !lib || !ctx.discounts || !ctx.discounts.length) return;

  // ---------- money ----------
  var FORMAT = String(ctx.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
  // shop.money_format is the STORE format; in another presentment currency swap in the cart's symbol.
  if (ctx.currencySymbol && ctx.storeCurrency && ctx.currency && ctx.currency !== ctx.storeCurrency) {
    FORMAT = FORMAT.replace(/^[^{]*/, ctx.currencySymbol);
  }
  function money(cents) {
    var value = cents / 100;
    var m = FORMAT.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var txt;
    switch (key) {
      case 'amount_no_decimals': txt = String(Math.round(value)); break;
      case 'amount_with_comma_separator': txt = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': txt = String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_with_apostrophe_separator': txt = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"); break;
      default: txt = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    // Theme convention: whole amounts drop the ".00".
    txt = txt.replace(/[.,]00$/, '');
    return m ? FORMAT.replace(m[0], txt) : txt;
  }

  // ---------- context ----------
  var variantMeta = {}; // variantId (numeric string) -> { productId, tags, collectionIds, compareAtCents, unitCents }
  (ctx.cart || []).forEach(function (l) { variantMeta[l.variantId.split('/').pop()] = { productId: l.productId, tags: l.productTags, collectionIds: l.collectionIds, compareAtCents: l.compareAtCents, unitCents: l.unitCents }; });
  if (ctx.product) Object.keys(ctx.product.variants).forEach(function (id) { var v = ctx.product.variants[id]; variantMeta[id] = { productId: ctx.product.id, tags: ctx.product.tags, collectionIds: ctx.product.collectionIds, compareAtCents: v.compareAtCents, unitCents: v.unitCents }; });

  function baseCtx() { return { currency: ctx.currency, customer: ctx.customer, lines: (ctx.cart || []).slice() }; }
  function candidate(productId, variantId, unitCents, compareAtCents, tags, collectionIds) {
    return { id: '__probe__', quantity: 1, unitCents: unitCents, compareAtCents: compareAtCents, productId: productId, variantId: variantId, productTags: tags || [], collectionIds: collectionIds || [] };
  }

  // ---------- rendering ----------
  var writing = false; // our own DOM writes must not re-trigger the observers
  function write(fn) { writing = true; try { fn(); } finally { setTimeout(function () { writing = false; }, 0); } }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  // Remember the theme's original markup the first time we touch an element, so a vanished saving
  // (membership removed, pack broken) restores the exact server-rendered state.
  function remember(container, saleEl, struckEl) {
    if (container.hasAttribute('data-fd-orig')) return;
    container.setAttribute('data-fd-orig', JSON.stringify({ sale: saleEl ? saleEl.textContent : null, struck: struckEl ? struckEl.textContent : null, struckHidden: !!(struckEl && struckEl.classList.contains('hide')), onSale: container.classList.contains('fd-price--on-sale') }));
  }
  function restore(container, saleEl, struckEl) {
    var raw = container.getAttribute('data-fd-orig'); if (!raw) return;
    var o = JSON.parse(raw);
    write(function () {
      var from = container.querySelector('.fd-from'); if (from) from.parentNode.removeChild(from);
      if (saleEl && o.sale !== null) setText(saleEl, o.sale);
      if (struckEl && o.struck !== null) setText(struckEl, o.struck);
      if (struckEl && struckEl.getAttribute('data-fd-created') === '1') struckEl.style.display = 'none';
      if (struckEl && o.struckHidden) struckEl.classList.add('hide');
      container.classList.toggle('fd-price--on-sale', !!o.onSale);
      container.removeAttribute('data-fd-applied');
    });
  }
  // Leaf price nodes only: the wrapper that also carries [data-product-price] in some templates must survive.
  function leaf(container, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var els = container.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) if (!els[j].children.length) return els[j];
    }
    return null;
  }

  // Some templates (singles, rugs) render no strike-through element at all; add one next to the price.
  function ensureStruck(container, saleEl, struckEl) {
    if (struckEl) return struckEl;
    var s = document.createElement('s');
    s.className = 'fd-was inline';
    s.style.cssText = 'color:#c4c4c4;text-decoration:line-through;margin-left:0.5rem;font-size:0.8em;display:none;';
    s.setAttribute('data-fd-created', '1');
    saleEl.parentNode.insertBefore(s, saleEl.nextSibling);
    return s;
  }

  // PDP fallback comes from the live variant data (the snapshot may belong to another variant).
  function restoreVariant(container, saleEl, struckEl, v, qty) {
    qty = qty > 0 ? qty : 1;
    write(function () {
      setText(saleEl, money(v.unitCents * qty));
      var hasCompare = v.compareAtCents && v.compareAtCents > v.unitCents;
      if (struckEl) {
        setText(struckEl, hasCompare ? money(v.compareAtCents * qty) : '');
        struckEl.classList.toggle('hide', !hasCompare);
        if (struckEl.getAttribute('data-fd-created') === '1') struckEl.style.display = hasCompare ? '' : 'none';
      }
      container.classList.toggle('fd-price--on-sale', !!hasCompare);
      container.removeAttribute('data-fd-applied');
    });
  }

  // "Save $X" (never a percentage): beside #product-price on the PDP (outside it, so the theme's own
  // price rewrites cannot drop it), inside the price element on cards.
  function savingEl(container, create) {
    var pdp = container.id === 'product-price';
    var host = pdp ? container.parentNode : container;
    var el = null;
    for (var i = 0; i < host.children.length; i++) if (host.children[i].classList.contains('fd-save')) el = host.children[i];
    if (!el && create) {
      el = document.createElement('span');
      el.className = 'fd-save';
      if (pdp) host.insertBefore(el, container.nextSibling); else host.appendChild(el);
    }
    return el;
  }
  function setSaving(container, text) {
    var el = savingEl(container, !!text);
    if (!el) return;
    write(function () { if (text) setText(el, text); else el.parentNode.removeChild(el); });
  }

  // prefix: "From " on cards whose variants differ in price. saving: the "Save $X" text.
  function render(container, saleEl, struckEl, unitCents, result, variant, qty, prefix, saving) {
    qty = qty > 0 ? qty : 1;
    if (!result || result.discountedCents >= result.unitCents) {
      setSaving(container, null);
      if (!container.hasAttribute('data-fd-applied')) return; // never touched by us: leave the theme's own markup alone
        struckEl = ensureStruck(container, saleEl, struckEl);
      remember(container, saleEl, struckEl);
      if (variant) restoreVariant(container, saleEl, struckEl, variant, qty); else restore(container, saleEl, struckEl);
      return;
    }
    struckEl = ensureStruck(container, saleEl, struckEl);
    remember(container, saleEl, struckEl);
    setSaving(container, saving || ('Save ' + money((result.unitCents - result.discountedCents) * qty)));
    write(function () {
      container.setAttribute('data-fd-applied', result.labels.join(' + '));
      setText(saleEl, money(result.discountedCents * qty));
      if (struckEl) {
        setText(struckEl, money(unitCents * qty)); struckEl.style.display = ''; struckEl.classList.remove('hide');
        // Struck original on the left, discounted price on the right.
        if (struckEl.parentNode === saleEl.parentNode && struckEl.previousSibling !== saleEl && struckEl.nextSibling !== saleEl) saleEl.parentNode.insertBefore(struckEl, saleEl);
        else if (struckEl.nextSibling !== saleEl) saleEl.parentNode.insertBefore(struckEl, saleEl);
        struckEl.style.marginRight = '0.5rem'; struckEl.style.marginLeft = '';
      }
      // "From" goes in front of the struck price: "From $419 $293.30".
      var from = container.querySelector('.fd-from');
      if (prefix) {
        if (!from) { from = document.createElement('span'); from.className = 'fd-from'; }
        setText(from, prefix);
        var first = struckEl || saleEl;
        if (from.nextSibling !== first) first.parentNode.insertBefore(from, first);
      } else if (from) from.parentNode.removeChild(from);
      container.classList.add('fd-price--on-sale'); // the theme's own "show the struck price" hook
    });
  }

  // ---------- PDP ----------
  function currentVariantId() {
    var sel = document.querySelector('[name="id"]');
    if (sel && sel.value) return String(sel.value);
    var fromUrl = new URL(window.location.href).searchParams.get('variant');
    return fromUrl ? String(fromUrl) : null;
  }
  function renderPdp() {
    var container = document.getElementById('product-price');
    if (!container || !ctx.product) return;
    var vid = currentVariantId() || Object.keys(ctx.product.variants)[0];
    var v = ctx.product.variants[vid];
    if (!v) return;
    var sale = leaf(container, ['[data-sale-price]', '[data-product-price]', '.fd-price__now']);
    var struck = leaf(container, ['[data-compare-price]', '.fd-price__was', 's.fd-was']);
    if (!sale) return;
    var probe = candidate(ctx.product.id, v.variantId, v.unitCents, v.compareAtCents, ctx.product.tags, ctx.product.collectionIds);
    var qty = currentQty();
    var result = lib.previewUnitPrice(ctx.discounts, baseCtx(), probe, Date.now(), qty);
    render(container, sale, struck, v.unitCents, result, v, qty);
    renderFlash(container, result && result.discountedCents < result.unitCents ? flashInfo(probe) : null);
  }

  // ---------- flash pill ----------
  // A product is in a flash sale when the price everyone gets right now carries a "Flash" label. The pill's
  // end date is the end of the discount that gives that label (shown in Pacific time, like the campaign
  // copy). When the product goes back to full price after that, it is "First time on sale" (bedding).
  function flashInfo(probe) {
    var now = Date.now();
    var guest = { currency: ctx.currency, customer: { loggedIn: false, tags: [] }, lines: [] };
    var r = lib.previewUnitPrice(ctx.discounts, guest, probe, now);
    if (!r || r.discountedCents >= r.unitCents) return null;
    var label = (r.labels || []).filter(function (l) { return /flash/i.test(l); })[0];
    if (!label) return null;
    var end = null;
    ctx.discounts.forEach(function (d) {
      if (!d.endsAt) return;
      var one = lib.previewUnitPrice([d], guest, probe, now);
      var t = Date.parse(d.endsAt);
      if (one && one.labels.indexOf(label) !== -1 && (end === null || t < end)) end = t;
    });
    if (end === null) return null;
    var after = lib.previewUnitPrice(ctx.discounts, guest, probe, end + 1000);
    var day = new Date(end).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/Los_Angeles' });
    return (after && after.discountedCents < after.unitCents ? 'Flash price' : 'First time on sale') + ' - ends ' + day;
  }
  function renderFlash(container, text) {
    var host = container.parentNode;
    var el = host.querySelector(':scope > .fd-flash');
    if (!text) { if (el) write(function () { el.parentNode.removeChild(el); }); return; }
    write(function () {
      if (!el) {
        el = document.createElement('span');
        el.className = 'fd-flash';
        var saving = savingEl(container, false);
        host.insertBefore(el, (saving || container).nextSibling);
      }
      setText(el, text);
    });
  }
  function currentQty() {
    var el = document.getElementById('Quantity');
    var qty = el ? parseInt(el.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  // ---------- cards ----------
  function renderCards(root) {
    var cards = (root || document).querySelectorAll('[data-fd-product]');
    if (!cards.length) return;
    var base = baseCtx();
    cards.forEach(function (el) {
      var price = parseInt(el.getAttribute('data-fd-price'), 10);
      if (!price) return;
      var compare = parseInt(el.getAttribute('data-fd-compare'), 10) || null;
      var tags = (el.getAttribute('data-fd-tags') || '').split(',').filter(Boolean);
      var cols = (el.getAttribute('data-fd-collections') || '').split(',').filter(Boolean).map(function (id) { return 'gid://shopify/Collection/' + id; });
      var productId = 'gid://shopify/Product/' + el.getAttribute('data-fd-product');
      var variantId = 'gid://shopify/ProductVariant/' + el.getAttribute('data-fd-variant');
      var probe = candidate(productId, variantId, price, compare, tags, cols);
      var sale = leaf(el, ['.fd-price__now']);
      var struck = leaf(el, ['.fd-price__was', 's.fd-was']);
      if (!sale) return;
      var result = lib.previewUnitPrice(ctx.discounts, base, probe);
      if (el.getAttribute('data-fd-varies') !== 'true') { render(el, sale, struck, price, result); return; }
      // "From $X" cards: data-fd-price is the lowest variant price. Keep the "From" wording, strike the lowest
      // price, and say "Save up to $X" from the highest one when the saving grows with the price.
      var orig = el.hasAttribute('data-fd-orig') ? JSON.parse(el.getAttribute('data-fd-orig')).sale : sale.textContent;
      var at = orig.indexOf(money(price));
      if (at < 0) return; // unexpected wording: leave the card as the theme rendered it
      var max = parseInt(el.getAttribute('data-fd-price-max'), 10) || price;
      var top = max > price ? lib.previewUnitPrice(ctx.discounts, base, candidate(productId, variantId, max, null, tags, cols)) : null;
      var saving = null;
      if (result && result.discountedCents < result.unitCents) {
        var low = result.unitCents - result.discountedCents;
        var high = top ? top.unitCents - top.discountedCents : low;
        saving = high > low ? 'Save up to ' + money(high) : 'Save ' + money(low);
      }
      render(el, sale, struck, price, result, null, 1, orig.slice(0, at).replace(/^\s+/, ''), saving);
    });
  }

  function refresh() { renderPdp(); renderCards(); }

  // ---------- cart updates keep line metadata ----------
  function hydrateLine(it) {
    var meta = variantMeta[String(it.variant_id)];
    // Collections are only known for variants seen in Liquid; unknown collections are treated as "not a member".
    // null collections = unknown; the evaluator leaves such lines out of collection-based estimates.
    return { id: it.key, quantity: it.quantity, unitCents: it.original_price, compareAtCents: meta ? meta.compareAtCents : null, productId: 'gid://shopify/Product/' + it.product_id, variantId: 'gid://shopify/ProductVariant/' + it.variant_id, productTags: meta ? meta.tags : null, collectionIds: meta && meta.collectionIds ? meta.collectionIds : null, handle: it.handle };
  }
  var cartGeneration = 0;
  function onCart(cart, gen) {
    if (!cart || !cart.items) return;
    if (gen === undefined) gen = ++cartGeneration;
    var lines = cart.items.map(hydrateLine);
    var unknown = lines.filter(function (l) { return l.productTags === null; });
    var fetches = unknown.map(function (l) {
      return fetch('/products/' + l.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) { l.productTags = []; return; }
        var v = (p.variants || []).filter(function (x) { return 'gid://shopify/ProductVariant/' + x.id === l.variantId; })[0];
        l.productTags = p.tags || []; l.compareAtCents = v && v.compare_at_price ? v.compare_at_price : null;
        variantMeta[l.variantId.split('/').pop()] = { productId: l.productId, tags: l.productTags, collectionIds: null, compareAtCents: l.compareAtCents, unitCents: l.unitCents };
      }).catch(function () { l.productTags = []; });
    });
    Promise.all(fetches).then(function () {
      if (gen !== cartGeneration) return; // a newer cart state superseded this one
      ctx.cart = lines.map(function (l) { delete l.handle; return l; }); refresh();
    }).catch(function () {});
  }
  document.addEventListener('cart:updated', function (e) { onCart(e && e.detail && e.detail.cart, ++cartGeneration); });
  // Cart drawer/AJAX carts that do not emit cart:updated: re-read the cart after any /cart/*.js call.
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/^(https?:\/\/[^/]+)?\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        var gen = ++cartGeneration; // sequence at request time so a slow older reread cannot win
        p.then(function (res) { if (res && res.ok) return origFetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { onCart(c, gen); }); }).catch(function () {});
      }
      return p;
    };
  }

  // Legacy theme flows (ShopifyAPI.* through jQuery.ajax) bypass fetch: re-read the cart after their mutations too.
  function hookJQuery() {
    var $ = window.jQuery;
    if (!$ || !$(document).ajaxComplete || hookJQuery.done) return;
    hookJQuery.done = true;
    $(document).ajaxComplete(function (e, xhr, settings) {
      var url = (settings && settings.url) || '';
      try {
        if (xhr && xhr.status >= 200 && xhr.status < 300 && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          var gen = ++cartGeneration;
          $.getJSON('/cart.js').done(function (c) { onCart(c, gen); });
        }
      } catch (err) { /* never let a preview failure reach other ajaxComplete handlers */ }
    });
  }
  hookJQuery();
  if (!hookJQuery.done) document.addEventListener('DOMContentLoaded', hookJQuery);

  // ---------- observers ----------
  var pdp = document.getElementById('product-price');
  if (pdp && window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (writing || pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; renderPdp(); });
    }).observe(pdp, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'id' || e.target.id === 'Quantity' || (e.target.classList && e.target.classList.contains('selectQty')))) setTimeout(renderPdp, 50); });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.buttonQty')) setTimeout(renderPdp, 60); });
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      if (writing) return;
      records.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) renderCards(n.matches && n.matches('[data-fd-product]') ? n.parentNode : n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Re-render when a scheduled discount starts or ends while the page is open, and keep re-arming.
  function armBoundary() {
    var boundary = lib.nextBoundary ? lib.nextBoundary(ctx.discounts) : null;
    if (!boundary) return;
    setTimeout(function () { refresh(); armBoundary(); }, Math.min(Math.max(boundary - Date.now(), 0) + 1000, 2147483647));
  }
  armBoundary();

  refresh();
})();
